import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { Pagination } from "../../../types/Pagination"
import { RootState } from "../../app/store"

export interface CraftmanState {
  pagination: Pagination
  query: string
}

const initialState: CraftmanState = {
  pagination: {
    page: 0,
    size: 10,
  },
  query: "",
}

export const craftmanSlice = createSlice({
  name: "craftman",
  initialState,
  reducers: {
    setCraftmanPagination: (state, action: PayloadAction<Pagination>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      }
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload
    },
  },
})
export const selectCraftmanPagination = (state: RootState) =>
  state.craftman.pagination
export const selectCraftmanQuery = (state: RootState) => state.craftman.query
export const { setCraftmanPagination, setQuery } = craftmanSlice.actions
export default craftmanSlice.reducer
